const userConfigActionTypes = {
  LOAD_CONFIGS: 'LOAD_CONFIGS',
  LOAD_CONFIGS_SUCCESS: 'LOAD_CONFIGS_SUCCESS',
};
export default userConfigActionTypes;
